import { TOrdering } from '../components/Table';
import { Order } from '../components/Table/SortSwitchers/SortSwitchers';

const mkRequestOrdering = (ordering?: TOrdering) =>
  ordering ? `${ordering.direction === Order.DESC ? '-' : ''}${ordering.name}` : undefined;

export default mkRequestOrdering;
